import { ACCOUNT_PLANS } from '../../../constants/acctountPlans';

export const isAccountPlanValid = (selectedPlan) =>
  selectedPlan === ACCOUNT_PLANS.PRO || selectedPlan === ACCOUNT_PLANS.RETAIL;
